(function($) {

  'use strict';

  function Projects() {

    var self = this,
      $filters = null,
      $groups = null,
      currentFilter = null,
      options = {
        'example': null
      };

    
    function setCurrentFilter($filter) {

      if (currentFilter === $filter.data('filter')) {
        return false;
      }

      var $activeGroup = $groups.parent().find('.js-active-group');
      var $toActivateGroup = $groups.parent().find(".js-filter-group[data-filter='" + $filter.data('filter') + "']");
      currentFilter = $filter.data('filter');

      $filters.removeClass('is-active');
      $filter.addClass('is-active');

      $activeGroup.removeClass('js-active-group').fadeOut('fast', function() {
          $toActivateGroup.fadeIn('fast').addClass('js-active-group');
      });
    }



    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      //extends options
      for (var i in opts) { options[i] = opts[i]; }

      $filters = $('.js-filter');
      $groups = $('.js-filter-group');

      currentFilter = $groups.parent().find('.js-active-group').data('filter');

      $filters.click(function(event) {
        var $this = $(this);
        var thisDataIndex = $this.data('index');
        setCurrentFilter($this);

        if(thisDataIndex == '0') {
          window.cache.$body.attr('data-filter-index', 'is-no-filter');
          window.cache.$body.removeAttr('data-filter');
        } else {
          window.cache.$body.attr('data-filter-index', 'is-filter-' + thisDataIndex);
          window.cache.$body.attr('data-filter', 'is-filter');
        }
      });
      


    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Projects = Projects;

}(jQuery));